// RoadmapSection.jsx
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const generateDotLine = (count = 50, iconMap = {}) => {
  return Array.from({ length: count }).map((_, i) => {
    const iconEntry = iconMap[i];
    if (iconEntry) {
      return (
        <div key={i} className="dot milestone">
          <FontAwesomeIcon icon={iconEntry.icon} />
        </div>
      );
    }
    return (
      <div key={i} className="dot">
        <div className="dot-circle neon-glow" />
      </div>
    );
  });
};

export default function DottedLine({ totalDots = 60, iconMap = {} }) {
  return (
    <div className="dotted-line-container">
      {generateDotLine(totalDots, iconMap)}
    </div>
  );
}
